import { parseDropdownValuesResponse } from '../models/dropdownValues.wire'
import type { DropdownValuesResponse } from '../models/schedule.types'

import { appHttp, decodeDto, unwrap } from '@/shared/http'

/** Point-read transport for one schedule/dimension dropdown slice (BE v2.4.0). */
export class DropdownValuesApi {
  constructor(private readonly app: Pick<typeof appHttp, 'get'> = appHttp) {}

  async fetchDropdownValues(
    accountId: number,
    workspaceId: number | string,
    scheduleId: number | string,
    dimension: string,
  ): Promise<DropdownValuesResponse> {
    const encodedDimension = encodeURIComponent(dimension)
    const body = unwrap(
      await this.app.get<unknown>(
        `/accounts/${accountId}/workspace/${workspaceId}/dropdownable_dimensions/${scheduleId}/${encodedDimension}`,
        {
          // A 404 is a valid "not dropdownable" result owned by the report store.
          suppressGlobalErrorHandler: true,
          meta: { suppressGlobalErrorHandler: true },
        },
      ),
    )
    const decoded = decodeDto(body, parseDropdownValuesResponse)
    if (
      String(decoded.data.workspace_id) !== String(workspaceId) ||
      String(decoded.data.schedule_id) !== String(scheduleId) ||
      decoded.data.dimension !== dimension
    ) {
      throw new TypeError('Mismatched dropdown values response')
    }
    return decoded
  }
}

export const dropdownValuesApi = new DropdownValuesApi()
